/** @jsx jsx */
import { Button as StyledButton, jsx } from 'theme-ui'
import { FC } from 'react'
import { ArrowRugs } from '~/components/icons/arrowRugs'
import { Link } from 'gatsby'
import { ButtonProps } from '~/@types/models'

export const ButtonRugs: FC<ButtonProps> = ({
  variant = 'primary',
  size = 'm',
  label,
  hasArrow = false,
  sxProps = {},
  as = 'button',
  to = '#',
  onClick,
  arrowOnly = false,
  mobileBlock = false,
  handle,
  ...rest
}) => {
  const buttonStyles = {
    height: 64,
    textAlign: 'center',
    minWidth: [160, null, null, 272],
    width: mobileBlock ? ['100%', 'initial'] : 'initial',
    fontFamily: 'body',
    borderWidth: '1px',
    borderStyle: 'solid',
    px: 15,
    svg: {
      ml: '10px',
    },
    borderRadius: 0,
    opacity: rest.disabled ? 0.5 : 1,
    cursor: rest.disabled ? 'default' : 'pointer',
    ...(size === 'sm' && {
      height: 40,
      minWidth: ['initial', null, null, 'initial'],
      fontSize: 2,
    }),
  }

  return as === 'button' ? (
    <StyledButton
      {...rest}
      onClick={onClick}
      // @ts-ignore
      sx={{
        ...buttonStyles,
        ...sxProps,
      }}
      variant={variant}
    >
      {handle === 'rugs' ? `${label.replace('Rugs', '')} Rugs` : label}
      {hasArrow && <ArrowRugs />}
    </StyledButton>
  ) : (
    <Link
      onClick={onClick}
      to={to}
      // @ts-ignore
      sx={{
        ...buttonStyles,
        variant: `buttons.${variant}`,
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        textDecoration: 'none',
        pointerEvents: rest.disabled ? 'none' : 'initial',
        ...sxProps,
      }}
      {...rest}
    >
      {label}
      {hasArrow && <ArrowRugs />}
    </Link>
  )
}
